let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dQll6")).then(() => parcelRequire('940Nh'));